module.exports = __webpack_public_path__ + "img/empty.a96bdeff.svg";